<div class="overlay">
  <span class="content">{{ text | translate }}</span>
</div>
